export const CUSTOM_TABLE = 'customTable';
export const FULL_ARCHITECTURE = 'fullArch';

import CustomTableIcon from '@svgIcons/datastream/custom-table.svg';
import FullArchitectureIcon from '@svgIcons/datastream/full-architecture.svg';
import TableIcon from '@svgIcons/datastream/table.svg';

import * as S from './style';
import { DUPLICATE_TRANSFER, EDIT_TRANSFER, SELECT_STREAM } from './';

const OPTIONS = {
    [CUSTOM_TABLE]: {
        title: 'EXPORT_DATA.stream_option_custom_table_title',
        description: 'EXPORT_DATA.stream_option_custom_table_description',
        icon: CustomTableIcon,
    },
    [FULL_ARCHITECTURE]: {
        title: 'EXPORT_DATA.stream_option_full_architecture_title',
        description: 'EXPORT_DATA.stream_option_full_architecture_description',
        icon: FullArchitectureIcon,
    },
};

export default {
    name: 'CreateTransfer',
    props: {
        streamType: String,
        page: String,
    },
    computed: {
        disabled() {
            return (
                this.page === EDIT_TRANSFER || this.page === DUPLICATE_TRANSFER
            );
        },
    },
    methods: {
        renderOptions() {
            const options = Object.entries(OPTIONS);

            return options.map(([key, value]) => {
                const { title, description, icon } = value;
                return (
                    <S.StreamItemWrapper
                        onClick={() => this.$emit('setStreamType', key)}
                        selected={this.streamType === key}
                        disabled={key === FULL_ARCHITECTURE}
                    >
                        <icon />
                        <S.StreamItemTitle>{this.$t(title)}</S.StreamItemTitle>
                        <S.StremItemDescription>
                            {this.$t(description)}
                        </S.StremItemDescription>
                    </S.StreamItemWrapper>
                );
            });
        },
        renderEditOptions() {
            const options = Object.entries(OPTIONS);
            return (
                <S.EditStreamWrapper disabled={this.disabled}>
                    <S.EditStreamTitle>
                        <TableIcon />
                        Type
                    </S.EditStreamTitle>
                    <S.EditStreamOptionsWrapper>
                        {options.map(([key, value]) => {
                            const { title, icon } = value;

                            return (
                                <S.EdtiStreamOptionItemWrapper
                                    onClick={() => {
                                        if (this.disabled) return;
                                        this.$emit('setStreamType', key);
                                    }}
                                    selected={this.streamType === key}
                                    disabled={this.disabled}
                                >
                                    <icon />
                                    <S.StreamItemTitle>
                                        {this.$t(title)}
                                    </S.StreamItemTitle>
                                </S.EdtiStreamOptionItemWrapper>
                            );
                        })}
                    </S.EditStreamOptionsWrapper>
                </S.EditStreamWrapper>
            );
        },
        renderCreateOptions() {
            return (
                <div>
                    <S.SelectStreamDescription>
                        {this.$t('EXPORT_DATA.panel_description_select_stream')}
                    </S.SelectStreamDescription>
                    <S.StreamOptionsWrapper>
                        {this.renderOptions()}
                    </S.StreamOptionsWrapper>
                </div>
            );
        },
    },
    mounted() {},
    render() {
        return this.page === SELECT_STREAM
            ? this.renderCreateOptions()
            : this.renderEditOptions();
    },
};
